export enum ModalTypes {
    ATS_SCAN_HISTORY = "ATS_SCAN_HISTORY",
    ADMIN_LAYOUT_FIELD_OPTIONS = "ADMIN_LAYOUT_FIELD_OPTIONS",
    ADD_LINK = "ADD_LINK",
    ADD_NEW_SECTION = "ADD_NEW_SECTION",
    ADMIN_SECTION_PREVIEW = "ADMIN_SECTION_PREVIEW",
    ASSISTANT_JOB_ROLE = "ASSISTANT_JOB_ROLE",
    ASSISTANT_PREFERENCES = "ASSISTANT_PREFERENCES",
    BUY_CREDITS = "BUY_CREDITS",
    CONFIRM = "CONFIRM",
    CONFIRMATION = "CONFIRMATION",
    CREDITS_INFO = "CREDITS_INFO",
    CREDITS_SUCCESS = "CREDITS_SUCCESS",
    CREDITS_WELCOME = "CREDITS_WELCOME",
    DELETE_ACCOUNT = "DELETE_ACCOUNT",
    DELETE_RESUME = "DELETE_RESUME",
    DESKTOP_ONLY = "DESKTOP_ONLY",
    DOWNLOAD_RESUME = "DOWNLOAD_RESUME",
    EDIT_IMAGE = "EDIT_IMAGE",
    HELP_GUIDE = "HELP_GUIDE",
    INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
    NEW_RESUME = "NEW_RESUME",
    DOCUMENT_LIMIT = "DOCUMENT_LIMIT",
    PLANS = "PLANS",
    PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
    PROMPT_HISTORY = "PROMPT_HISTORY",
    REARRANGE = "REARRANGE",
    REFERRAL = "REFERRAL",
    RENAME_RESUME = "RENAME_RESUME",
    RESUME_ADMIN = "RESUME_ADMIN",
    RESUME_PREVIEW = "RESUME_PREVIEW",
    TOUR = "TOUR",
    VERIFY_EMAIL = "VERIFY_EMAIL",
    MANAGE_USER_JOB = "MANAGE_USER_JOB",
    USER_JOB_RESUMES = "USER_JOB_RESUMES",
    SMART_MATCH = "SMART_MATCH",
    ARCHIVED_JOBS = "ARCHIVED_JOBS",
    IMPORT_RESUME_DEBUG = "IMPORT_RESUME_DEBUG",
}
